import type { Editor } from '@tiptap/core'
import type { TSlashCommandTarget } from '@/lib/slash-command-definition'

/**
 * Composer context for the TTSlash suggestion extensions, provided by the
 * composers so slash command suggestions can be filtered by what we know of
 * the event being composed (kind, tags, author, and relays when fixed).
 *
 * Stored per-editor (extension storage) instead of module-global so multiple
 * mounted composers (main post box, reply boxes) don't clobber each other.
 */
export type TComposerContext = TSlashCommandTarget

export function getEditorContext(editor: Editor | null | undefined): TComposerContext | null {
  return editor?.storage?.slashCommand?.context ?? null
}

export function setEditorContext(
  editor: Editor | null | undefined,
  value: TComposerContext | null
) {
  if (editor?.storage?.slashCommand) {
    editor.storage.slashCommand.context = value
  }
}
